import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
@Component({
  selector: "app-errormessagelist",
  templateUrl: "./errormessagelist.component.html",
  styleUrls: ["./errormessagelist.component.scss"]
})
export class ErrormessagelistComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  tabs = [];
  mode = "";
  id = "";
  name = "";
  objectId = "";
  objectName = "";
  // displayedColumns: string[] = ["label", "name"];

  // dataSource: any[] = [];

  displayedColumns: string[] = [
    "action",
    "message",
    "errorcode",
    "language",
    "type"
  ];
  dataSource = "";
  matchingrule: any;
  errormessages: any;

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }
  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.getErrorMessage();
  }

  cancel() {
    this.router.navigateByUrl("/home");
  }
  new() {
    this.router.navigateByUrl("/home/errormessage/new");
  }

  getErrorMessage() {
    return new Promise((resolve, reject) => {
      console.log("geterrormessages");

      // alert(id)
      const organizationid = localStorage.getItem("crm_orgid");
      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getErrorMessage(domain, subdomain, organizationid)
        .subscribe(
          (res) => {
            console.log("res", res);

            if (res.success == 1) {
              this.errormessages = res.data.errormessage;
              console.log("Doneeee****", this.errormessages);

              if (this.errormessages != null) {
                this.dataSource = this.errormessages.map((item) => ({
                  id: item.id,
                  // label: item.labelname,

                  message: item.messagetemplate,
                  errorcode: item.errorcode,
                  language: item.languagecode,
                  errorcodeid: item.errorcodeid,
                  // modifiedby: item.modifiedby,
                  // modifieddate: item.modifieddate,

                  // type: item.organizationid,
                  // type: item.organizationid ? item.organizationid : 'common',
                  type: item.organizationid ? "Tenant" : "Common"

                  // content: item.content,
                  // metalayoutid: item.metalayoutid,
                }));
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }

  editApp(element: any) {
    this.router.navigateByUrl("/home/errormessage/edit/" + element.id);
  }

  delete(id: any, errorcodeid: any, type: any) {
    // alert(id)
    console.log(id);
    console.log(errorcodeid);
    console.log(type);

    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }
    this.isLoading = true;
    this.dataService.deleteErrorMessage(id, type, domain, subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")

          this.showSuccess(res.message);
          this.isLoading = false;

          window.location.reload();
        } else {
          console.log("Failed to delete!");
          this.isLoading = false;
          this.showError(res.message);
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.showError(err.message);
      }
    );
  }
}
